import React from "react";
import "./WhiteLabel.css";

const content = {
  pt: {
    eyebrow: "White-label",
    title: "Leve leitura digital e atividades cognitivas para a sua marca.",
    subtitle:
      "Criamos experiências com identidade visual personalizada para empresas, redes de cuidado, editoras e parceiros que querem oferecer valor recorrente em um aplicativo próprio.",
    compareTitle: "Da experiência padrão a uma solução com a sua identidade",
    compareText:
      "O Kito pode seguir com a experiência principal da plataforma ou ganhar uma apresentação personalizada no login e na jornada inicial, como já acontece em projetos de parceria.",
    bullets: [
      "Login e ambientação com a identidade da sua marca",
      "Leitura digital, minibooks e experiências interativas",
      "Atividades cognitivas em projetos selecionados",
      "Estrutura pronta para relacionamento, engajamento e recorrência",
    ],
    defaultLabel: "Experiência Kito",
    whiteLabelLabel: "Exemplo white-label",
    ctaTitle: "Quer imaginar sua marca aqui também?",
    ctaText:
      "Fale com a gente para desenhar uma proposta comercial, editorial ou institucional sob medida.",
    emailLabel: "Enviar e-mail",
    email: "contato@kito.app.br",
    whatsappLabel: "Chamar no WhatsApp",
    whatsappHref: "https://wa.me/5511987599856",
  },
  en: {
    eyebrow: "White-label",
    title: "Bring digital reading and cognitive activities to your brand.",
    subtitle:
      "We create personalized branded experiences for companies, care networks, publishers, and partners that want to deliver recurring value through their own app environment.",
    compareTitle: "From the standard experience to a solution with your identity",
    compareText:
      "Kito can remain as the platform's standard experience or be adapted with a customized login and onboarding flow, as already happens in partner projects.",
    bullets: [
      "Login and onboarding with your brand identity",
      "Digital reading, mini books, and interactive experiences",
      "Cognitive activities in selected partnership projects",
      "A ready structure for relationship, engagement, and recurrence",
    ],
    defaultLabel: "Kito experience",
    whiteLabelLabel: "White-label example",
    ctaTitle: "Want to picture your brand here too?",
    ctaText:
      "Talk to us to design a commercial, editorial, or institutional proposal tailored to your context.",
    emailLabel: "Send email",
    email: "contato@kito.app.br",
    whatsappLabel: "Chat on WhatsApp",
    whatsappHref: "https://wa.me/5511987599856",
  },
  es: {
    eyebrow: "White-label",
    title: "Lleva lectura digital y actividades cognitivas a tu marca.",
    subtitle:
      "Creamos experiencias personalizadas para empresas, redes de cuidado, editoriales y socios que quieren ofrecer valor recurrente con una app con identidad propia.",
    compareTitle: "De la experiencia estándar a una solución con tu identidad",
    compareText:
      "Kito puede mantenerse como experiencia principal de la plataforma o adaptarse con login y recorrido inicial personalizados, como ya ocurre en proyectos asociados.",
    bullets: [
      "Login y ambientación con la identidad de tu marca",
      "Lectura digital, minibooks y experiencias interactivas",
      "Actividades cognitivas en proyectos seleccionados",
      "Estructura lista para relación, engagement y recurrencia",
    ],
    defaultLabel: "Experiencia Kito",
    whiteLabelLabel: "Ejemplo white-label",
    ctaTitle: "Quieres imaginar tu marca aquí también?",
    ctaText:
      "Habla con nosotros para diseñar una propuesta comercial, editorial o institucional a medida.",
    emailLabel: "Enviar correo",
    email: "contato@kito.app.br",
    whatsappLabel: "Hablar por WhatsApp",
    whatsappHref: "https://wa.me/5511987599856",
  },
};

export default function WhiteLabel() {
  const raw =
    localStorage.getItem("kitoLang") ||
    (navigator.language || "pt").slice(0, 2);
  const lang = ["pt", "en", "es"].includes(raw) ? raw : "pt";
  const t = content[lang] || content.pt;

  return (
    <main className="whitelabel-page">
      <section className="whitelabel-hero">
        <span className="whitelabel-eyebrow">{t.eyebrow}</span>
        <h1>{t.title}</h1>
        <p>{t.subtitle}</p>
      </section>

      <section className="whitelabel-panel">
        <div className="whitelabel-copy">
          <h2>{t.compareTitle}</h2>
          <p>{t.compareText}</p>
          <ul className="whitelabel-list">
            {t.bullets.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>

        <div className="whitelabel-showcase">
          <article className="whitelabel-screen">
            <span className="whitelabel-screen-label">{t.defaultLabel}</span>
            <div className="whitelabel-screen-frame">
              <img
                src="/images/print-kito.png"
                alt="Tela padrão do Kito"
                loading="lazy"
                width="260"
                height="560"
              />
            </div>
          </article>

          <article className="whitelabel-screen">
            <span className="whitelabel-screen-label">{t.whiteLabelLabel}</span>
            <div className="whitelabel-screen-frame">
              <img
                src="/images/print-acuidar.png"
                alt="Tela white-label"
                loading="lazy"
                width="260"
                height="560"
              />
            </div>
          </article>
        </div>
      </section>

      <section className="whitelabel-cta">
        <div className="whitelabel-cta-card">
          <h2>{t.ctaTitle}</h2>
          <p>{t.ctaText}</p>
          <div className="whitelabel-actions">
            <a className="whitelabel-primary" href={`mailto:${t.email}`}>
              {t.emailLabel}
            </a>
            <a
              className="whitelabel-secondary"
              href={t.whatsappHref}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t.whatsappLabel}
            </a>
          </div>
        </div>
      </section>
    </main>
  );
}
